import { FieldArray, useFormikContext } from 'formik'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormAddAnotherButton } from './FormAddAnotherButton'
import { FormDeleteFieldButton } from './FormDeleteFieldButton'
import { FormSelect } from './FormSelect'
import uuid from 'react-uuid'
import { SearchableSelect } from './SearchableSelect'

export default function FormSelectMultiplePartners({
  partnerOptions,
  readOnly,
  allBranches,
  contactIndex,
  partnerSelectionDisabled,
}) {
  const { t } = useTranslation()
  partnerOptions = partnerOptions?.map((partner) => {
    return { label: partner.name, value: partner.id }
  })
  const {
    values: { contact_partners, contact_branches },
  } = useFormikContext()
  let partner = contact_partners[contactIndex] ?? ''
  if (!partner && partnerSelectionDisabled) {
    partner = contact_partners[0] ?? ''
    partner ? contact_partners.push(partner) : null
  }
  const hasPartnerOptions = partnerOptions.map((pr) => pr.value).includes(partner)

  const getBranchOptions = (partnerId) => {
    let selectedPartner = partnerOptions.filter((partner) => partner.value == partnerId)[0]
    let branches = []
    if (!selectedPartner) {
      let parent_id = allBranches.find((branch) => branch.id == partnerId).parent_id
      selectedPartner = partnerOptions.find((partner) => partner.value == parent_id)
      branches = allBranches.filter((branch) => branch.parent_id === parent_id)
    } else {
      branches = allBranches.filter((branch) => branch.parent_id === partnerId)
    }
    branches = branches.map((branch) => {
      return { label: branch?.name, value: branch?.id }
    })
    branches.unshift({ label: selectedPartner.label + ' (HQ)', value: selectedPartner.value })
    return branches
  }

  if (partner && getBranchOptions(partner).length > 0) {
    let selectedBranch = contact_branches[contactIndex] ?? ''
    if (!selectedBranch && partnerSelectionDisabled) {
      selectedBranch = contact_branches[0] ?? ''
      selectedBranch ? contact_branches.push(selectedBranch) : null
    }
  }
  return (
    <>
      {((!readOnly && partner === '') || hasPartnerOptions) && (
        <div className="w-2 h-2 position-relative">
          <p className="spartan-font">{t('Backoffice.branches.table.columns.partner')}</p>
          <SearchableSelect
            className="my-2 form-control-backoffice"
            placeholder={t('Backoffice.Wizard.label.partner')}
            name={`contact_partners.${contactIndex}`}
            id={`contact_partners.${contactIndex}`}
            options={partnerOptions}
            disabled={readOnly}
          />
          {partner && getBranchOptions(partner).length > 0 && (
            <SearchableSelect
              className="my-2 form-control-backoffice"
              placeholder={t('Backoffice.branches.table.columns.branch')}
              name={`contact_branches.${contactIndex}`}
              id={`contact_branches.${contactIndex}`}
              options={getBranchOptions(partner)}
              disabled={readOnly}
            />
          )}
        </div>
      )}
    </>
  )
}
